module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login_page"
  }, [_c('transition', {
    attrs: {
      "name": "form-fade",
      "mode": "in-out"
    }
  }, [_c('div', [_c('div', {
    staticClass: "item"
  }, [_c('section', {
    staticClass: "form_contianer loginForm"
  }, [_c('div', {
    staticClass: "manage_tip"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("加阳华枫快运")])]), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.rules,
      "size": "medium"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "60px"
    },
    attrs: {
      "prop": "userName"
    }
  }, [_c('span', {
    staticClass: "fa-tips"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), _c('el-input', {
    staticClass: "area",
    attrs: {
      "type": "text",
      "placeholder": "用户名"
    },
    model: {
      value: (_vm.loginForm.userName),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "userName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "loginForm.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "fa-tips"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })]), _vm._v(" "), _c('el-input', {
    staticClass: "area",
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item'), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('el-button', {
    staticClass: "submit_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.login('loginForm')
      }
    }
  }, [_vm._v("登录")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tiparea"
  }), _vm._v(" "), _c('div', {
    staticClass: "icp-info"
  }, [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t上海华枫新达供应链有限公司 沪ICP备2025137398号-1\n\t\t\t\t\t\t\t")])])], 1)], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf5a1d2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/login.vue
// module id = 1262
// module chunks = 2